import { HttpInterceptorFn } from '@angular/common/http';
import {inject, LOCALE_ID} from "@angular/core";

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(LOCALE_ID);

  return next(req.clone({
    headers: req.headers.append('X-Requested-With', 'XMLHttpRequest')
      .append('Accept', 'application/json')
      .append('Locale', locale)
  }));
};
